import { adminAxios, contarctAxios } from "../../axiosConfig/InstancesAxios";

export default {
  createContract: (Model) => {
    return contarctAxios.post("/createContract", Model);
  },

  createProductContractCarte:(Model)=>{
     return contarctAxios.post("/createProductContractCarte", Model);
  },

  getAllContractsByCustomer: (idcustomer) => {
    return contarctAxios.post("/getAllcontractsbyCustomer", null, {
      params: { idcustomer },
    });
  },
  getProductByName: (name) => {
    return adminAxios.post("/getProductByName", null, { params: { name } });
  },
   getProductInfo: (idproduct) => {
    return adminAxios.post("/getAllproductinfobyproduct", null, {
      params: { idproduct },
    });
  },
   getMarqueByProduct: (idProduct) => {
    return adminAxios.post("/getMarqueByProduct", null, {
      params: { idProduct },
    });
  },
  getAllCarteContractsbyCustomer: (idcustomer) => {
    return contarctAxios.post("/getAllCarteContractsbyCustomer", null, {
      params: { idcustomer },
    });
  },

  getAllContractsByProducts: (IdProduct) => {
    return contarctAxios.post("/getallcontractsbyproducts", {
      params: { IdProduct },
    });
  },

  getContractbyId: (idContract) => {
    return contarctAxios.post("/getContractbyId", null, {
      params: { idContract },
    });
  },
  getContractInclusion: (matricule, num) => {
    return contarctAxios.post("/getContractInclusion", null, {
      params: {matricule, num },
    });
  },

  getTypePayment: () => {
    return contarctAxios.get("/getListTypePayment", {});
  },

  payment: (data) => {
    return contarctAxios.post("/payment", data);
  },

  sign: (model) => {
    return contarctAxios.post("/ngsign", model);
  },
  checkStepers: (Model) => {
    return contarctAxios.post("/checkStepers", Model);
  },
  generateContrat: (idConstructionSite) => {
    return contarctAxios.post("/generateContrat", null, {
      params: { idConstructionSite },
    });
  },
  validatePayment: (orderID) => {
    return contarctAxios.post("/validatePayment", null, {
      params: { orderID },
    });
  },
  updateStatusOfContract: (model) => {
    return contarctAxios.post("/updateStatusOfContract", model);
  },
  upload: (file) => {
    return contarctAxios.post("/upload", file);
  },
  uploadFiles: (files) => {
    return contarctAxios.post("/uploadM", files);
  },
  generateContratBase64: (idConstructionSite) => {
    return contarctAxios.post("/generateContratB64", null, {
      params: { idConstructionSite },
    });
  },
  voucherCheck: (code, fomula) => {
    return contarctAxios.post("/checkVoucher", null, {
      params: { code, fomula },
    });
  },
   loginWithCardNumber: (number) => {
    return contarctAxios.post("/loginWithCardNumber", null, {
      params: { number },
    });
  },
   checkPhoneNumber: (cardNumber,phoneNumber) => {
    return contarctAxios.post("/checkPhoneNumber", null, {
      params: { cardNumber, phoneNumber },
    });
  },
  sendCodeSearchByPhone: (phoneNumber) => {
    return contarctAxios.post("/sendCodeSearchByPhone", null, {
      params: { phoneNumber },
    });
  },
   
  createContartctWithVoucher :(model)=>{
    return contarctAxios.post("/quickCreateContractWithVoucher", model);
  },

   getvalueinfobyidcontract :(idContract)=>{
    return contarctAxios.post("/getvalueinfobyidcontract", null, {
      params: { idContract },
    });
  }
  
};
